/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SaveBankAccountDto = {
    /**
     * ISO-3166 alpha-2 country code. Drives which identifier fields are required.
     */
    country: SaveBankAccountDto.country;
    /**
     * Full name as per bank records
     */
    accountHolderName: string;
    /**
     * Name of the bank
     */
    bankName: string;
    /**
     * India: bank account number (9–18 digits). Required when country is IN.
     */
    accountNumber?: string;
    /**
     * India: must match accountNumber. Required when country is IN.
     */
    confirmAccountNumber?: string;
    /**
     * India: IFSC code (e.g. SIBL0000123). Required when country is IN.
     */
    ifscCode?: string;
    /**
     * International Bank Account Number. Required for manual-rail countries (AE, NL). Whitespace/hyphens are stripped and letters uppercased before validation so the grouped display form (e.g. "AE07 0331 2345 ...") is accepted.
     */
    iban?: string;
    /**
     * Optional SWIFT/BIC code (manual rail)
     */
    swiftCode?: string;
};
export namespace SaveBankAccountDto {
    /**
     * ISO-3166 alpha-2 country code. Drives which identifier fields are required.
     */
    export enum country {
        IN = 'IN',
        AE = 'AE',
        NL = 'NL',
    }
}

